export const UI = {
  ru: {
    desktopLabel: 'Рабочий стол',
    appLabel: 'Резюме Слатимова Андрея',
    close: 'Закрыть',
    tabsLabel: 'Разделы резюме',
    sectionOpened: 'Открыт раздел',
    download: 'Скачать резюме',
    downloadTitle: 'Загрузка резюме',
    downloadStatus: 'Скачивание резюме…',
    downloadError: 'Не удалось скачать файл. Попробуйте ещё раз.',
    settings: 'Настройки',
    language: 'Язык',
    langRu: 'Русский',
    langEn: 'English',
    tabs: {
      main: 'Главная',
      experience: 'Опыт работы',
      education: 'Образование',
      certificates: 'Сертификаты',
      aboutApp: 'О приложении',
    },
    profile: {
      photoAlt: 'Фото',
      name: 'Имя',
      position: 'Должность',
      about: 'О себе',
      contacts: 'Контакты',
      email: 'Email',
      phone: 'Телефон',
      telegram: 'Telegram',
      gitlab: 'GitLab',
    },
    experience: {
      title: 'Опыт работы',
      company: 'Место работы',
      role: 'Роль',
      period: 'Период',
      duties: 'Что делал',
    },
    education: {
      title: 'Образование',
      degree: 'Степень',
      years: 'Годы',
    },
    certificates: {
      title: 'Сертификаты',
      issuer: 'Выдан',
      date: 'Дата',
    },
    aboutApp: {
      title: 'О приложении',
    },
  },
  en: {
    desktopLabel: 'Desktop',
    appLabel: 'CV of Andrey Slatimov',
    close: 'Close',
    tabsLabel: 'CV sections',
    sectionOpened: 'Opened section',
    download: 'Download CV',
    downloadTitle: 'Downloading CV',
    downloadStatus: 'Downloading CV…',
    downloadError: 'Could not download the file. Please try again.',
    settings: 'Settings',
    language: 'Language',
    langRu: 'Русский',
    langEn: 'English',
    tabs: {
      main: 'Home',
      experience: 'Experience',
      education: 'Education',
      certificates: 'Certificates',
      aboutApp: 'About',
    },
    profile: {
      photoAlt: 'Photo',
      name: 'Name',
      position: 'Position',
      about: 'About me',
      contacts: 'Contacts',
      email: 'Email',
      phone: 'Phone',
      telegram: 'Telegram',
      gitlab: 'GitLab',
    },
    experience: {
      title: 'Work experience',
      company: 'Workplace',
      role: 'Role',
      period: 'Period',
      duties: 'Responsibilities',
    },
    education: {
      title: 'Education',
      degree: 'Degree',
      years: 'Years',
    },
    certificates: {
      title: 'Certificates',
      issuer: 'Issued by',
      date: 'Date',
    },
    aboutApp: {
      title: 'About the app',
    },
  },
};
